import React, { createContext, useState } from "react";

const FilterDataContext = createContext();

const dateIni = new Date();
const dateEnd = new Date().setDate(dateIni.getDate() + 90);

const defaultData = {
  priority: "0",
  accountnumber: "0",
  classification: "A",
  noticedescriptionid: "0",
  duedatestart: dateIni,
  duedateend: dateEnd,
  status: "X",
  filtered: false,
};

const FilterDataProvider = (props) => {
  const [data, setData] = useState(defaultData);
  const [opened, setOpened] = useState("close");
  const [executeFilter, setExecuteFilter] = useState("no");
  const [dataCIF, setDataCIF] = useState([]);
  const [dataCIFFilter, setDataCIFFilter] = useState([]);

  const UpdateFilter = ({
    priority,
    accountnumber,
    classification,
    noticedescriptionid,
    duedatestart,
    duedateend,
    status,
    filtered,
  }) => {
    const filter = {
      priority: priority,
      accountnumber: accountnumber,
      classification: classification,
      noticedescriptionid: noticedescriptionid,
      duedatestart: duedatestart,
      duedateend: duedateend,
      status: status,
      filtered: filtered,
    };

    setData(filter);
  };

  const ClearFilter = () => setData(defaultData);

  const GetFilter = () => data;

  const OpenFilter = () => setOpened("open");

  const CloseFilter = () => setOpened("close");

  const IsOpen = () => opened === "open";

  const GetDefaultData = () => defaultData;

  const SetCIFList = (list) => setDataCIF(list);

  const GetCIFList = () => dataCIF;

  const SetCIFListFilter = (list) => setDataCIFFilter(list);

  const GetCIFListFilter = () => dataCIFFilter;

  return (
    <FilterDataContext.Provider
      value={{
        UpdateFilter,
        ClearFilter,
        GetFilter,
        OpenFilter,
        CloseFilter,
        IsOpen,
        GetDefaultData,
        executeFilter,
        setExecuteFilter,
        SetCIFList,
        GetCIFList,
        SetCIFListFilter,
        GetCIFListFilter,
      }}
    >
      {props.children}
    </FilterDataContext.Provider>
  );
};

export { FilterDataContext, FilterDataProvider };
